import { createReducer, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../lib/api";

const initialState = {
    list: [],
    budget: []
}

const expenseSlice = createSlice({
    name: 'expense',
    initialState,
    reducers: {
        addExpense : (state, action) => {
            return{
                ...state,
                list: action.payload
            }
        },
        deleteExpense: (state, action) => {
            return {
                ...state,
                list: action.payload
            }
        },
        addBudget : (state, action) => {
            return{
                ...state,
                budget: action.payload
            }
        },
        // deleteExpense: (state, action) => {
        //     return {
        //         ...state,
        //         list: action.payload
        //     }
        // }
    }
})


export const { addExpense, deleteExpense, addBudget } = expenseSlice.actions
export default expenseSlice.reducer